(function() {
  var LoadingHandler, ScrollHelper, ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LoadingHandler = App.loadClass("core::FullPageLoadingHandler");

  ValidationEngine = App.loadClass("core::ValidationEngine");

  ScrollHelper = App.load("core::ScrollHelper");

  exports.Hybrids_Dialog = (function(superClass) {
    extend(Hybrids_Dialog, superClass);

    function Hybrids_Dialog() {
      return Hybrids_Dialog.__super__.constructor.apply(this, arguments);
    }

    Hybrids_Dialog.prototype.init = function() {
      var opt;
      this.layoutUrl = 'backend/portal/hybrids/report';
      this.saveUrl = 'backend/portal/hybrids/save-inventory';
      this.excelUrl = 'backend/portal/hybrids/excel';
      this.param_filters = ko.toJSON(this.parent.sidebar.jsonize());
      opt = {
        postOptions: {
          query: this.param_filters
        }
      };
      this.createDialog(opt);
      this.loader = this.createSubHandler(LoadingHandler);
      if (this.loader) {
        return this.loader.init("Loading Inventory...");
      }
    };

    Hybrids_Dialog.prototype.updateAvailableForHybridRow = function(index, Element) {
      var available, forecasted, ordered;
      forecasted = $(this).find('.hybrids-forecasted-input').val();
      available = $(this).find('.available')[0].outerText;
      if (!forecasted && available) {
        forecasted = 0;
      }
      if (!isNaN(parseFloat(forecasted)) && isFinite(forecasted)) {
        ordered = $(this).find('.ordered').html();
        available = forecasted - ordered;
        return $(this).find('.available').html(available);
      }
    };

    Hybrids_Dialog.prototype.updateCounts = function() {
      return $('.hybrids-line').each(this.updateAvailableForHybridRow);
    };

    Hybrids_Dialog.prototype.validationPassed = function() {
      var h, hd, hybrid_id, i, j, k, len, len1, len2, lot_id, ref, ref1, ref2, s;
      this.updateCounts();
      this.saveData = {
        'hybrids': {}
      };
      ref = this.dialog.find('input.to-save.hybrids-forecasted-input');
      for (i = 0, len = ref.length; i < len; i++) {
        h = ref[i];
        hybrid_id = $(h).data('hybrid-id');
        if (this.saveData['hybrids'][hybrid_id] == null) {
          this.saveData['hybrids'][hybrid_id] = {};
        }
        this.saveData['hybrids'][hybrid_id]['forcasted'] = $(h).val();
      }
      ref1 = this.dialog.find('input.to-save.hybrid-checkbox');
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        hd = ref1[j];
        hybrid_id = $(hd).data('hybrid-id');
        if (this.saveData['hybrids'][hybrid_id] == null) {
          this.saveData['hybrids'][hybrid_id] = {};
        }
        this.saveData['hybrids'][hybrid_id]['disabled'] = $(hd).prop('checked');
      }
      ref2 = this.dialog.find('input.to-save.lot-checkbox');
      for (k = 0, len2 = ref2.length; k < len2; k++) {
        s = ref2[k];
        hybrid_id = $(s).data('hybrid-id');
        lot_id = $(s).data('lot-id');
        if (this.saveData['hybrids'][hybrid_id] == null) {
          this.saveData['hybrids'][hybrid_id] = {};
        }
        if (this.saveData['hybrids'][hybrid_id]['lots'] == null) {
          this.saveData['hybrids'][hybrid_id]['lots'] = {};
        }
        this.saveData['hybrids'][hybrid_id]['lots'][lot_id] = $(s).prop('checked');
      }
      return this.save('Saving Inventory...');
    };

    Hybrids_Dialog.prototype.afterLoadLayout = function(selector, response) {
      var ref, size;
      this.loader.closeDialog();
      this.openDialog();
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      $(":text, :checkbox").bind('focus', function() {
        return $(this).addClass('to-save');
      });
      $('.hybrids-line-expandable').each(function() {
        var id;
        id = $(this).data('hybrid-id');
        if ($("[data-parent-hybrid-id='" + id + "']").length === 0) {
          $(this).find('.header-icon').remove();
          $(this).removeClass('hybrids-line-expandable');
          return $(this).addClass('hybrids-nonexpandable-spacer');
        }
      });
      $('.lots-line-expandable').each(function() {
        var id;
        id = $(this).data('lot-id');
        if ($("[data-parent-lot-id='" + id + "']").length === 0) {
          $(this).find('.header-icon').remove();
          $(this).removeClass('lots-line-expandable');
          return $(this).addClass('lots-nonexpandable-spacer');
        }
      });
      $('.hybrids-line-expandable').bind('click', function() {
        var id;
        id = $(this).data('hybrid-id');
        $("[data-parent-hybrid-id='" + id + "']").toggleClass('hidden-by-hybrid');
        return $(this).find('.header-icon').toggle();
      });
      $('.lots-line-expandable').bind('click', function() {
        var id;
        id = $(this).data('lot-id');
        $("[data-parent-lot-id='" + id + "']").toggleClass('hidden-by-lot');
        return $(this).find('.header-icon').toggle();
      });
      this.dialog.find('input.hybrids-forecasted-input').mask('?999999999', {
        placeholder: ''
      });
      this.validator = new ValidationEngine();
      this.validator.makeFormValidator('hybrids', '#hybrids_form', '.errorDiv', (function(_this) {
        return function(valid) {
          if (valid) {
            return _this.validationPassed();
          } else {

          }
        };
      })(this));
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          return _this.validator.validateAll();
        };
      })(this));
      this.dialog.delegate('.excel-btn', 'click', (function(_this) {
        return function(e) {
          var url;
          url = _this.excelUrl + "?query=" + (encodeURIComponent(_this.param_filters));
          return window.open(url, '_blank');
        };
      })(this));
      this.dialog.find('.cancel-btn').removeAttr('data-dismiss').bind('click', (function(_this) {
        return function() {
          return _this.refresh();
        };
      })(this));
      size = this.dialog.find('.modal-body').height() - 40;
      this.table = this.dialog.find(".table").dataTable({
        sScrollY: size + "px",
        bPaginate: false,
        bFilter: false,
        bInfo: false,
        bSort: false
      });
      return $(window).unbind('modal_resized').bind('modal_resized', debounce((function(_this) {
        return function(e) {
          var ref1;
          if (((ref1 = _this.table) != null ? ref1.fnSettings() : void 0) != null) {
            size = _this.dialog.find('.modal-body').height() - 40;
            _this.table.fnSettings().sY = size + "px";
            _this.dialog.find('.dataTables_scrollBody').height(size);
            return _this.table.fnAdjustColumnSizing();
          }
        };
      })(this)));
    };

    return Hybrids_Dialog;

  })(FullPageHandler);

}).call(this);
